import { useQuery } from '@tanstack/react-query'
import { Link } from 'react-router-dom'
import { coursesApi } from '../../api/courses'
import { subscriptionsApi } from '../../api/subscriptions'
import Header from '../../components/layout/Header'
import Footer from '../../components/layout/Footer'
import Loading from '../../components/common/Loading'
import CourseCard from '../../components/course/CourseCard'
import { FiCheckCircle, FiXCircle } from 'react-icons/fi'
import './MyCourses.css'

const MyCourses = () => {
  const { data: coursesData, isLoading: coursesLoading } = useQuery({
    queryKey: ['my-courses'],
    queryFn: async () => {
      const response = await coursesApi.getCourses({ my_courses: true })
      return response
    },
  })

  const { data: subscriptionsData } = useQuery({
    queryKey: ['user-subscriptions'],
    queryFn: () => subscriptionsApi.getUserSubscriptions(),
  })

  if (coursesLoading) {
    return (
      <>
        <Header />
        <Loading fullScreen text="جاري التحميل..." />
        <Footer />
      </>
    )
  }

  const courses = coursesData?.data?.courses || []
  const subscriptions = subscriptionsData?.data?.subscriptions || []
  // A null expires_at means the subscription never expires, so it has to be
  // matched before the date comparison — new Date(null) is the epoch.
  const activeSubscription = subscriptions.find(
    sub => sub.status === 'active' && (!sub.expires_at || new Date(sub.expires_at) > new Date())
  )

  return (
    <div className="my-courses-page bg-gray-900 min-h-screen">
      <Header />
      <main className="my-courses-main bg-gray-900">
        <div className="container mx-auto px-4 py-8">
          <div className="page-header">
            <h1 className="page-title text-white">دوراتي</h1>
            {activeSubscription && (
              <div className="subscription-badge">
                <FiCheckCircle />
                <span>
                  {activeSubscription.expires_at
                    ? `اشتراك نشط حتى ${new Date(activeSubscription.expires_at).toLocaleDateString('ar-EG')}`
                    : 'اشتراك نشط'}
                </span>
              </div>
            )}
          </div>

          {courses.length > 0 ? (
            <div className="courses-grid">
              {courses.map((course) => (
                <CourseCard key={course.id} course={course} />
              ))}
            </div>
          ) : (
            <div className="empty-state">
              {activeSubscription ? (
                <>
                  <p>لا توجد دورات مشتركة حالياً</p>
                  <Link to="/courses" className="browse-button">
                    تصفح الدورات
                  </Link>
                </>
              ) : (
                <>
                  <FiXCircle className="empty-icon" />
                  <p>لا يوجد لديك اشتراك نشط</p>
                  <p className="empty-subtitle">اشترك الآن للوصول إلى جميع الدورات</p>
                  <Link to="/subscriptions" className="browse-button">
                    عرض الباقات
                  </Link>
                </>
              )}
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  )
}

export default MyCourses

